import { createSupabaseBrowserClient } from '@memorai/auth/client';
import { getWebConfig } from '@memorai/config';

const { supabaseUrl, supabaseAnonKey } = getWebConfig(import.meta.env);

if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Missing Supabase environment variables');
}

export const supabase = createSupabaseBrowserClient(supabaseUrl, supabaseAnonKey);
